(() => {
  const t = (key, fallback) => (window.tsT ? window.tsT('sourcing', key, fallback) : fallback);
  const fallbacks = {
    condition: ['OBSERVATION 01 / CONDITION', 'The details the listing leaves out.', 'Bodywork, interior, underside and visible wear. We review the available inspection information and flag what needs a closer look.'],
    history: ['OBSERVATION 02 / HISTORY', 'Every car has a past.', 'Auction sheets, available records and ownership history help us understand the example in front of us. We highlight gaps as well as the information we can verify.'],
    specification: ['OBSERVATION 03 / SPECIFICATION', 'The right version of the right car.', 'Factory specification, options and modifications. We compare the details with your brief, so an interesting listing becomes an informed choice.']
  };
  const observation = name => fallbacks[name] && ['label', 'heading', 'text'].map((part, i) => t(`${name}_${part}`, fallbacks[name][i]));

  function initialize(root) {
    if (root.dataset.journalInitialized) return;
    root.dataset.journalInitialized = 'true';
    const find = name => root.querySelector(`[data-sj="${name}"]`);
    const inspectionButtons = [...root.querySelectorAll('[data-inspect]')];
    inspectionButtons.forEach(button => button.addEventListener('click', () => {
      const content = observation(button.dataset.inspect);
      if (!content) return;
      inspectionButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      ['inspection-label', 'inspection-heading', 'inspection-text'].forEach((name, index) => {
        find(name).textContent = content[index];
      });
    }));

    const form = find('search-form');
    if (!form || form.querySelector('[data-form-success]')) return;
    const steps = [...form.querySelectorAll('.sj-form-step')];
    const progress = root.querySelector('.sj-form-progress');
    const next = find('form-next');
    const back = find('form-back');
    const review = find('brief-review');
    if (!steps.length || !progress || !next || !back || !review) return;
    let step = 0;
    let reviewing = false;

    function showStep(index, focus = true) {
      step = index;
      reviewing = false;
      review.hidden = true;
      steps.forEach((element, i) => { element.hidden = i !== step; });
      [...progress.children].forEach((element, i) => {
        if (i === step) element.setAttribute('aria-current', 'step');
        else element.removeAttribute('aria-current');
      });
      back.hidden = step === 0;
      next.firstChild.textContent = `${step === steps.length - 1 ? t('review', 'Review search brief') : t('continue', 'Continue')} `;
      if (focus) steps[step].querySelector('input, select, textarea').focus();
    }

    function invalidField(container) {
      return [...container.querySelectorAll('input, select, textarea')].find(input => !input.checkValidity());
    }

    function showReview() {
      const values = new FormData(form);
      const fields = [
        [t('field_vehicle', 'Vehicle'), 'Looking for'], [t('field_make_model', 'Make / model'), 'Make / Model'], [t('field_wishlist', 'Wish list'), 'body'],
        [t('field_budget', 'Budget'), 'Budget range'], [t('field_destination', 'Destination'), 'Destination'], [t('field_timing', 'Timing'), 'Timing'],
        [t('field_name', 'Name'), 'name'], [t('field_email', 'Email'), 'email'], [t('field_whatsapp', 'WhatsApp'), 'WhatsApp']
      ];
      // Submitted values stay English for the merchant; the review shows the visible (translated) choice.
      const shown = key => {
        const name = `contact[${key}]`;
        const select = [...form.querySelectorAll('select')].find(input => input.name === name);
        if (select) return select.selectedOptions[0]?.textContent || '';
        const radio = [...form.querySelectorAll('input[type="radio"]')].find(input => input.name === name && input.checked);
        if (radio) return radio.closest('label')?.querySelector('span')?.textContent || radio.value;
        return values.get(name) || '';
      };
      const target = find('review-fields');
      target.replaceChildren();
      fields.forEach(([label, key]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const value = document.createElement('dd');
        term.textContent = label;
        value.textContent = String(shown(key)).trim() || t('not_specified', 'Not specified');
        row.append(term, value);
        target.append(row);
      });
      steps.forEach(element => { element.hidden = true; });
      [...progress.children].forEach(element => element.removeAttribute('aria-current'));
      review.hidden = false;
      back.hidden = true;
      next.firstChild.textContent = `${t('send', 'Send sourcing request')} `;
      reviewing = true;
      review.focus();
    }

    /* Step navigation must never fire a submit event: Shopify's contact-form captcha
       listens for the first submit, runs its (usually invisible) challenge and then
       sends the form itself, which skipped the remaining steps. So "Continue" is a
       plain button, Enter in a field advances, and only "Send" submits (through
       requestSubmit, so the captcha and Shopify's own handling still run). */
    function advance() {
      if (reviewing) {
        const invalid = invalidField(form);
        if (invalid) {
          showStep(steps.findIndex(element => element.contains(invalid)));
          invalid.reportValidity();
          return;
        }
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
        return;
      }
      const invalid = invalidField(steps[step]);
      if (invalid) { invalid.reportValidity(); return; }
      if (step < steps.length - 1) showStep(step + 1);
      else showReview();
    }

    next.type = 'button';
    next.addEventListener('click', advance);
    form.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || event.isComposing) return;
      const field = event.target;
      if (!field.matches?.('input:not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="button"])')) return;
      event.preventDefault();
      advance();
    });
    form.addEventListener('submit', event => {
      if (!reviewing) event.preventDefault(); // safety net: nothing leaves the page before the review
    });
    back.addEventListener('click', () => showStep(Math.max(0, step - 1)));
    find('edit-brief').addEventListener('click', () => showStep(0));
    form.noValidate = true;
    root.classList.add('is-enhanced');
    progress.hidden = false;
    showStep(0, false);
  }

  function initializeAll(scope) {
    if (scope.matches?.('[data-search-journal]')) initialize(scope);
    scope.querySelectorAll('[data-search-journal]').forEach(initialize);
  }
  initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
